// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"582":"a8b4c293aa097af8","651":"843bcd36c9bf4c15"}[chunkId] + ".js";
};